[
    {
        "name": "ACQ_ACTIVATOR_CONC",
        "isACTive": false,
        "description": "Activator Conc"
    },
    {
        "name": "ACQ_ACTIVATOR_RATE",
        "isACTive": false,
        "description": "Activator Rate"
    },
    {
        "name": "ACQ_AUX_1",
        "isACTive": false,
        "description": "Auxiliary 1"
    },
    {
        "name": "ACQ_AUX_2",
        "isACTive": false,
        "description": "Auxiliary 2"
    },
    {
        "name": "ACQ_AUX_3",
        "isACTive": false,
        "description": "Auxiliary 3"
    },
    {
        "name": "ACQ_AUX_4",
        "isACTive": false,
        "description": "Auxiliary 4"
    },
    {
        "name": "ACQ_AUX_5",
        "isACTive": false,
        "description": "Auxiliary 5"
    },
    {
        "name": "ACQ_AUX_LIQUID_ADD_CONC_1",
        "isACTive": false,
        "description": "Aux Liquid Add Conc 1"
    },
    {
        "name": "ACQ_AUX_LIQUID_ADD_CONC_2",
        "isACTive": false,
        "description": "Aux Liquid Add Conc 2"
    },
    {
        "name": "ACQ_AUX_LIQUID_ADD_CONC_3",
        "isACTive": false,
        "description": "Aux Liquid Add Conc 3"
    },
    {
        "name": "ACQ_AUX_LIQUID_ADD_CONC_4",
        "isACTive": false,
        "description": "Aux Liquid Add Conc 4"
    },
    {
        "name": "ACQ_AUX_LIQUID_ADD_CONC_5",
        "isACTive": false,
        "description": "Aux Liquid Add Conc 5"
    },
    {
        "name": "ACQ_AUX_PRESSURE_1",
        "isACTive": false,
        "description": "Aux Pressure 1"
    },
    {
        "name": "ACQ_AUX_PRESSURE_2",
        "isACTive": false,
        "description": "Aux Pressure 2"
    },
    {
        "name": "ACQ_AUX_PRESSURE_3",
        "isACTive": false,
        "description": "Aux Pressure 3"
    },
    {
        "name": "ACQ_AUX_PRESSURE_4",
        "isACTive": false,
        "description": "Aux Pressure 4"
    },
    {
        "name": "ACQ_AUX_PRESSURE_5",
        "isACTive": false,
        "description": "Aux Pressure 5"
    },
    {
        "name": "ACQ_AUX_RATE_1",
        "isACTive": false,
        "description": "Aux Rate 1"
    },
    {
        "name": "ACQ_AUX_RATE_2",
        "isACTive": false,
        "description": "Aux Rate 2"
    },
    {
        "name": "ACQ_AUX_RATE_3",
        "isACTive": false,
        "description": "Aux Rate 3"
    },
    {
        "name": "ACQ_AUX_RATE_4",
        "isACTive": false,
        "description": "Aux Rate 4"
    },
    {
        "name": "ACQ_AUX_RATE_5",
        "isACTive": false,
        "description": "Aux Rate 5"
    },
    {
        "name": "ACQ_AUX_SOLID_ADD_CONC_1",
        "isACTive": false,
        "description": "Aux Solid Add Conc 1"
    },
    {
        "name": "ACQ_AUX_SOLID_ADD_CONC_2",
        "isACTive": false,
        "description": "Aux Solid Add Conc 2"
    },
    {
        "name": "ACQ_AUX_SOLID_ADD_CONC_3",
        "isACTive": false,
        "description": "Aux Solid Add Conc 3"
    },
    {
        "name": "ACQ_AUX_SOLID_ADD_CONC_4",
        "isACTive": false,
        "description": "Aux Solid Add Conc 4"
    },
    {
        "name": "ACQ_AUX_SOLID_ADD_CONC_5",
        "isACTive": false,
        "description": "Aux Solid Add Conc 5"
    },
    {
        "name": "ACQ_BREAKER_RATE",
        "isACTive": false,
        "description": "Breaker Rate"
    },
    {
        "name": "ACQ_BUFFER_CONC",
        "isACTive": false,
        "description": "Buffer Conc"
    },
    {
        "name": "ACQ_BUFFER_RATE",
        "isACTive": false,
        "description": "Buffer Rate"
    },
    {
        "name": "ACQ_CROSSLINKER_CONC",
        "isACTive": false,
        "description": "Cross-Linker Conc"
    },
    {
        "name": "ACQ_CROSSLINKER_RATE",
        "isACTive": false,
        "description": "Cross-Linker Rate"
    },
    {
        "name": "ACQ_FLD_LOSS_ADD_CONC",
        "isACTive": false,
        "description": "Fluid Loss Add Conc"
    },
    {
        "name": "ACQ_FLD_LOSS_ADD_RATE",
        "isACTive": false,
        "description": "Fluid Loss Add Rate"
    },
    {
        "name": "ACQ_FLD_PH",
        "isACTive": false,
        "description": "Fluid pH"
    },
    {
        "name": "ACQ_FLD_TEMP",
        "isACTive": false,
        "description": "Fluid Temp"
    },
    {
        "name": "ACQ_FLD_VISC",
        "isACTive": false,
        "description": "Fluid Viscosity"
    },
    {
        "name": "ACQ_FOAMER_CONC",
        "isACTive": false,
        "description": "Foamer Conc"
    },
    {
        "name": "ACQ_FOAMER_RATE",
        "isACTive": false,
        "description": "Foamer Rate"
    },
    {
        "name": "ACQ_FRIC_REDUCER_CONC",
        "isACTive": false,
        "description": "Friction Reducer Conc"
    },
    {
        "name": "ACQ_FRIC_REDUCER_RATE",
        "isACTive": false,
        "description": "Friction Reducer Rate"
    },
    {
        "name": "ACQ_LIQ_BRKR_CONC_1",
        "isACTive": false,
        "description": "Liquid Breaker Conc 1"
    },
    {
        "name": "ACQ_LIQ_BRKR_CONC_2",
        "isACTive": false,
        "description": "Liquid Breaker Conc 2"
    },
    {
        "name": "ACQ_LIQ_BRKR_RATE_1",
        "isACTive": false,
        "description": "Liquid Breaker Rate 1"
    },
    {
        "name": "ACQ_LIQ_BRKR_RATE_2",
        "isACTive": false,
        "description": "Liquid Breaker Rate 2"
    },
    {
        "name": "ACQ_MIXING_DENSITY",
        "isACTive": false,
        "description": "Mixing Density"
    },
    {
        "name": "ACQ_SOLID_BREAKER_CONC1",
        "isACTive": false,
        "description": "Solid Breaker Conc 1"
    },
    {
        "name": "ACQ_SOLID_BREAKER_CONC2",
        "isACTive": false,
        "description": "Solid Breaker Conc 2"
    },
    {
        "name": "ACQ_SOLID_BREAKER_RATE1",
        "isACTive": false,
        "description": "Solid Breaker Rate 1"
    },
    {
        "name": "ACQ_SOLID_BREAKER_RATE2",
        "isACTive": false,
        "description": "Solid Breaker Rate 2"
    },
    {
        "name": "ACQ_STAB_CONC_1",
        "isACTive": false,
        "description": "Stabilizer Conc 1"
    },
    {
        "name": "ACQ_STAB_CONC_2",
        "isACTive": false,
        "description": "Stabilizer Conc 2"
    },
    {
        "name": "ACQ_STAB_RATE_1",
        "isACTive": false,
        "description": "Stabilizer Rate 1"
    },
    {
        "name": "ACQ_STAB_RATE_2",
        "isACTive": false,
        "description": "Stabilizer Rate 2"
    },
    {
        "name": "ADD_RATE_1",
        "isACTive": false,
        "description": "Additive Rate 1"
    },
    {
        "name": "ADD_RATE_2",
        "isACTive": false,
        "description": "Additive Rate 2"
    },
    {
        "name": "ADD_VOL_1",
        "isACTive": false,
        "description": "Total Add Vol 1"
    },
    {
        "name": "ADD_VOL_2",
        "isACTive": false,
        "description": "Total Add Vol 2"
    },
    {
        "name": "AIR_PRESSURE_CTU",
        "isACTive": false,
        "description": "Air Pressure CTU"
    },
    {
        "name": "AIR_PRESSURE_PUMP",
        "isACTive": false,
        "description": "Air Pressure Pump"
    },
    {
        "name": "ANNULAR_VELOCITY_HIGH_RISK",
        "isACTive": false,
        "description": "Annular Velocity High Risk"
    },
    {
        "name": "ANNULAR_VELOCITY_LOW_RISK",
        "isACTive": false,
        "description": "Annular Velocity Low Risk"
    },
    {
        "name": "AN_PRES2",
        "isACTive": false,
        "description": "Annulus Pressure Backup"
    },
    {
        "name": "AN_PRESS",
        "isACTive": false,
        "description": "Annular Pressure"
    },
    {
        "name": "AN_PRESS2",
        "isACTive": false,
        "description": "Annular Pressure 2"
    },
    {
        "name": "APILOG_EFFECTIVE_DIVERSION",
        "isACTive": false,
        "description": "Effective Diversion"
    },
    {
        "name": "APILOG_EFFECTIVE_STIM",
        "isACTive": false,
        "description": "Effective Stimulation"
    },
    {
        "name": "APILOG_FRICTION_POOH",
        "isACTive": false,
        "description": "Friction Coef. POOH"
    },
    {
        "name": "APILOG_FRICTION_POOH_HIGH_RISK",
        "isACTive": false,
        "description": "POOH Friction High Risk"
    },
    {
        "name": "APILOG_FRICTION_POOH_LOW_RISK",
        "isACTive": false,
        "description": "POOH Friction Low Risk"
    },
    {
        "name": "APILOG_FRICTION_RIH",
        "isACTive": false,
        "description": "Friction Coef. RIH"
    },
    {
        "name": "APILOG_FRICTION_RIH_HIGH_RISK",
        "isACTive": false,
        "description": "RIH Friction High Risk"
    },
    {
        "name": "APILOG_FRICTION_RIH_LOW_RISK",
        "isACTive": false,
        "description": "RIH Friction Low Risk"
    },
    {
        "name": "APILOG_INEFFECTIVE_STIM",
        "isACTive": false,
        "description": "Ineffective Stimulation"
    },
    {
        "name": "APILOG_NO_DIVERSION",
        "isACTive": false,
        "description": "No Diversion"
    },
    {
        "name": "APILOG_NO_LONGER_EFFECTIVE_STIM",
        "isACTive": false,
        "description": "No Longer Effective Stimulation"
    },
    {
        "name": "API_ANNVEL",
        "isACTive": false,
        "description": "Annular Velocity"
    },
    {
        "name": "API_CT_SPEED_POOH",
        "isACTive": false,
        "description": "CT Speed POOH"
    },
    {
        "name": "API_CT_SPEED_RIH",
        "isACTive": false,
        "description": "CT Speed RIH"
    },
    {
        "name": "API_OVERBAL",
        "isACTive": false,
        "description": "Worst Overbalance"
    },
    {
        "name": "API_SOLCONC",
        "isACTive": false,
        "description": "Proppant Concentration"
    },
    {
        "name": "AUX_1",
        "isACTive": false,
        "description": "AUX_1"
    },
    {
        "name": "AUX_2",
        "isACTive": false,
        "description": "AUX_2"
    },
    {
        "name": "AUX_3",
        "isACTive": false,
        "description": "AUX_3"
    },
    {
        "name": "AUX_4",
        "isACTive": false,
        "description": "AUX_4"
    },
    {
        "name": "AUX_BOP_RAM",
        "isACTive": false,
        "description": "Aux BOP Ram"
    },
    {
        "name": "AUX_BOP_VALVE",
        "isACTive": false,
        "description": "Aux BOP Valve"
    },
    {
        "name": "BACKUP_DEPTH_1",
        "isACTive": false,
        "description": "Backup Depth 1"
    },
    {
        "name": "BACKUP_DEPTH_2",
        "isACTive": false,
        "description": "Backup Depth 2"
    },
    {
        "name": "BACKUP_DEPTH_3",
        "isACTive": false,
        "description": "Backup Depth 3"
    },
    {
        "name": "BACKUP_DEPTH_4",
        "isACTive": false,
        "description": "Backup Depth 4"
    },
    {
        "name": "BACKUP_PRESS",
        "isACTive": false,
        "description": "Backup Pressure"
    },
    {
        "name": "BACKUP_PRESS1",
        "isACTive": false,
        "description": "Backup Pressure"
    },
    {
        "name": "BACKUP_PRESS2",
        "isACTive": false,
        "description": "Backup Pressure 2"
    },
    {
        "name": "BACKUP_PRESS3",
        "isACTive": false,
        "description": "Backup Pressure 3"
    },
    {
        "name": "BACKUP_PRESS4",
        "isACTive": false,
        "description": "Backup Pressure 4"
    },
    {
        "name": "BACKUP_PRESS5",
        "isACTive": false,
        "description": "Backup Pressure 5"
    },
    {
        "name": "BACKUP_PRESS6",
        "isACTive": false,
        "description": "Backup Pressure 6"
    },
    {
        "name": "BACKUP_PRESS7",
        "isACTive": false,
        "description": "Backup Pressure 7"
    },
    {
        "name": "BACKUP_PRESS8",
        "isACTive": false,
        "description": "Backup Pressure 8"
    },
    {
        "name": "BHA_FLUID_0",
        "isACTive": false,
        "description": "BHA Fluid 1"
    },
    {
        "name": "BHA_FLUID_1",
        "isACTive": false,
        "description": "BHA Fluid 2"
    },
    {
        "name": "BHA_FLUID_2",
        "isACTive": false,
        "description": "BHA Fluid 3"
    },
    {
        "name": "BHA_FLUID_3",
        "isACTive": false,
        "description": "BHA Fluid 4"
    },
    {
        "name": "BHA_FLUID_4",
        "isACTive": false,
        "description": "BHA Fluid 5"
    },
    {
        "name": "BHA_FLUID_5",
        "isACTive": false,
        "description": "BHA Fluid 6"
    },
    {
        "name": "BHA_FLUID_6",
        "isACTive": false,
        "description": "BHA Fluid 7"
    },
    {
        "name": "BHA_FLUID_7",
        "isACTive": false,
        "description": "BHA Fluid 8"
    },
    {
        "name": "BHA_FLUID_8",
        "isACTive": false,
        "description": "BHA Fluid 9"
    },
    {
        "name": "BHA_FLUID_9",
        "isACTive": false,
        "description": "BHA Fluid 10"
    },
    {
        "name": "BHA_LENGTH",
        "isACTive": false,
        "description": "Length of BHA"
    },
    {
        "name": "BHA_NITRIFIED",
        "isACTive": false,
        "description": "Nitrified BHA Fluid"
    },
    {
        "name": "BHCFLDRATE",
        "isACTive": false,
        "description": "Clean Fluid Rate (BH)"
    },
    {
        "name": "BHP_CALC",
        "isACTive": false,
        "description": "BHP Calculated"
    },
    {
        "name": "BHP_CALC2",
        "isACTive": false,
        "description": "BHP Calculated-2"
    },
    {
        "name": "BHP_CALC_ZONE1",
        "isACTive": false,
        "description": "BHP - Zone 1"
    },
    {
        "name": "BHP_CALC_ZONE10",
        "isACTive": false,
        "description": "BHP - Zone 10"
    },
    {
        "name": "BHP_CALC_ZONE2",
        "isACTive": false,
        "description": "BHP - Zone 2"
    },
    {
        "name": "BHP_CALC_ZONE3",
        "isACTive": false,
        "description": "BHP - Zone 3"
    },
    {
        "name": "BHP_CALC_ZONE4",
        "isACTive": false,
        "description": "BHP - Zone 4"
    },
    {
        "name": "BHP_CALC_ZONE5",
        "isACTive": false,
        "description": "BHP - Zone 5"
    },
    {
        "name": "BHP_CALC_ZONE6",
        "isACTive": false,
        "description": "BHP - Zone 6"
    },
    {
        "name": "BHP_CALC_ZONE7",
        "isACTive": false,
        "description": "BHP - Zone 7"
    },
    {
        "name": "BHP_CALC_ZONE8",
        "isACTive": false,
        "description": "BHP - Zone 8"
    },
    {
        "name": "BHP_CALC_ZONE9",
        "isACTive": false,
        "description": "BHP - Zone 9"
    },
    {
        "name": "BH_CO2_DENSITY",
        "isACTive": false,
        "description": "CO2 Density (BH)"
    },
    {
        "name": "BH_CO2_RATE",
        "isACTive": false,
        "description": "CO2 Rate (BH)"
    },
    {
        "name": "BH_CO2_VOL_F",
        "isACTive": false,
        "description": "CO2 Volume Factor (BH)"
    },
    {
        "name": "BH_FOAM_QUALITY",
        "isACTive": false,
        "description": "Foam Quality (BH)"
    },
    {
        "name": "BH_INJ_RATE",
        "isACTive": false,
        "description": "Injection Rate (BH)"
    },
    {
        "name": "BH_N2RATE",
        "isACTive": false,
        "description": "N2 Rate (BH)"
    },
    {
        "name": "BH_N2_DENSITY",
        "isACTive": false,
        "description": "N2 Density (BH)"
    },
    {
        "name": "BH_N2_VOL_FACT",
        "isACTive": false,
        "description": "N2 Volume Factor (BH)"
    },
    {
        "name": "BH_PRES",
        "isACTive": false,
        "description": "BHP Measured"
    },
    {
        "name": "BH_PRES2",
        "isACTive": false,
        "description": "BHP Measured-2"
    },
    {
        "name": "BH_PRESS",
        "isACTive": false,
        "description": "BHP"
    },
    {
        "name": "BH_PRESS_ACQ",
        "isACTive": false,
        "description": "BH_PRESS_ACQ"
    },
    {
        "name": "BH_PRESS_PAC",
        "isACTive": false,
        "description": "BH_PRESS_PAC"
    },
    {
        "name": "BH_PROP_CON",
        "isACTive": false,
        "description": "Prop Conc (BH)"
    },
    {
        "name": "BH_STATIC_TEMP",
        "isACTive": false,
        "description": "BHST"
    },
    {
        "name": "BH_TEMP",
        "isACTive": false,
        "description": "BHT"
    },
    {
        "name": "BH_TOT_SLUR",
        "isACTive": false,
        "description": "Total Slurry (BH)"
    },
    {
        "name": "BLENDER_RATE",
        "isACTive": false,
        "description": "BLENDER_RATE"
    },
    {
        "name": "BLEN_RATE",
        "isACTive": false,
        "description": "Blender Rate"
    },
    {
        "name": "BLN_DENS",
        "isACTive": false,
        "description": "Density At Blender"
    },
    {
        "name": "BOP_ACCUMULATOR_PRESSURE",
        "isACTive": false,
        "description": "BOPAccumulatorPressure"
    },
    {
        "name": "BOP_BLIND_RAM_POSITION",
        "isACTive": false,
        "description": "BOP Blind Ram Position"
    },
    {
        "name": "BOP_BLIND_RAM_VALVE",
        "isACTive": false,
        "description": "BOP Blind Ram Valve"
    },
    {
        "name": "BOP_ENERGIZE",
        "isACTive": false,
        "description": "BOP Energize"
    },
    {
        "name": "BOP_PIPE_RAM_POSITION",
        "isACTive": false,
        "description": "BOP Pipe Ram Position"
    },
    {
        "name": "BOP_PIPE_RAM_VALVE",
        "isACTive": false,
        "description": "BOP Pipe Ram Valve"
    },
    {
        "name": "BOP_SHEAR_RAM_POSITION",
        "isACTive": false,
        "description": "BOP Shear Ram Position"
    },
    {
        "name": "BOP_SHEAR_RAM_VALVE",
        "isACTive": false,
        "description": "BOP Shear Ram Valve"
    },
    {
        "name": "BOP_SLIP_RAM_POSITION",
        "isACTive": false,
        "description": "BOP Slip Ram Position"
    },
    {
        "name": "BOP_SLIP_RAM_VALVE",
        "isACTive": false,
        "description": "BOP Slip Ram Valve"
    },
    {
        "name": "BOP_SUPPLY_PRESSURE",
        "isACTive": false,
        "description": "BOP Supply Pressure"
    },
    {
        "name": "BOP_VALVE1",
        "isACTive": false,
        "description": "BOP Valve 1"
    },
    {
        "name": "BOP_VALVE2",
        "isACTive": false,
        "description": "BOP Valve 2"
    },
    {
        "name": "BOP_VALVE3",
        "isACTive": false,
        "description": "BOP Valve 3"
    },
    {
        "name": "BOP_VALVE4",
        "isACTive": false,
        "description": "BOP Valve 4"
    },
    {
        "name": "BREAKER_RATE",
        "isACTive": false,
        "description": "BREAKER_RATE"
    },
    {
        "name": "BUFFER_RATE",
        "isACTive": false,
        "description": "BUFFER_RATE"
    },
    {
        "name": "CBHP_AT_ZONE_CALC_BHP",
        "isACTive": false,
        "description": "BHP At Zone"
    },
    {
        "name": "CEMENT_PUMP_RATE1",
        "isACTive": false,
        "description": "Cement Pump Rate 1"
    },
    {
        "name": "CEMENT_PUMP_RATE2",
        "isACTive": false,
        "description": "Cement Pump Rate 2"
    },
    {
        "name": "CEMENT_PUMP_RATE3",
        "isACTive": false,
        "description": "Cement Pump Rate 3"
    },
    {
        "name": "CEMENT_PUMP_RATE4",
        "isACTive": false,
        "description": "Cement Pump Rate 4"
    },
    {
        "name": "CFLD_RATE",
        "isACTive": false,
        "description": "Clean Fluid Rate"
    },
    {
        "name": "CFLD_RATE",
        "isACTive": false,
        "description": "CFLD_RATE"
    },
    {
        "name": "CHAIN_DIRECTION",
        "isACTive": false,
        "description": "Chain direction"
    },
    {
        "name": "CHAIN_SPEED",
        "isACTive": false,
        "description": "Chain speed"
    },
    {
        "name": "CHAIN_TENSION",
        "isACTive": false,
        "description": "Outside Chain Tension"
    },
    {
        "name": "CHAIN_TENSION_PRESSURE",
        "isACTive": false,
        "description": "Outside Chain Tension Pressure"
    },
    {
        "name": "CHAIN_TENSION_RECOMMENDED",
        "isACTive": false,
        "description": "Chain Tension Recommended"
    },
    {
        "name": "CIRC_PRESS",
        "isACTive": false,
        "description": "Circulation Pressure"
    },
    {
        "name": "CIRC_PRESS2",
        "isACTive": false,
        "description": "Circulation Pressure 2"
    },
    {
        "name": "CLIENT_REF",
        "isACTive": false,
        "description": "Client Reference to Ground"
    },
    {
        "name": "CO2FOAMQUAL",
        "isACTive": false,
        "description": "CO2 Foam Quality"
    },
    {
        "name": "CO2STGGAS",
        "isACTive": false,
        "description": "CO2 Stage Gas"
    },
    {
        "name": "CO2TOTGAS",
        "isACTive": false,
        "description": "CO2 Total Gas"
    },
    {
        "name": "CO2_DENSITY",
        "isACTive": false,
        "description": "CO2 Density"
    },
    {
        "name": "CO2_RATE",
        "isACTive": false,
        "description": "CO2 Rate"
    },
    {
        "name": "CO2_RATE1",
        "isACTive": false,
        "description": "CO2 Rate (Backup 1)"
    },
    {
        "name": "CO2_RATE2",
        "isACTive": false,
        "description": "CO2 Rate (Backup 2)"
    },
    {
        "name": "CO2_RDM_RATE",
        "isACTive": false,
        "description": "CO2 Roadmap Rate"
    },
    {
        "name": "COMPUTED_BHP",
        "isACTive": false,
        "description": "Computed BHP"
    },
    {
        "name": "CROSSLINKER_RATE",
        "isACTive": false,
        "description": "CROSSLINKER_RATE"
    },
    {
        "name": "CTPS_CURRENT_STAGE_VOLUME",
        "isACTive": false,
        "description": "CTPS_CURRENT_STAGE_VOLUME"
    },
    {
        "name": "CTPS_FLUID_TYPE_EXIT",
        "isACTive": false,
        "description": "CTPS_FLUID_TYPE_EXIT"
    },
    {
        "name": "CT_CORR_DEPTH",
        "isACTive": false,
        "description": "Corrected Depth"
    },
    {
        "name": "CT_DIRECTION",
        "isACTive": false,
        "description": "CT Direction"
    },
    {
        "name": "CT_MEAS_DEPTH",
        "isACTive": false,
        "description": "CT Measured Depth"
    },
    {
        "name": "CT_OD_AVG",
        "isACTive": false,
        "description": "CT OD Average"
    },
    {
        "name": "CT_OD_MAX",
        "isACTive": false,
        "description": "CT OD Maximum"
    },
    {
        "name": "CT_OD_MIN",
        "isACTive": false,
        "description": "CT OD Miminum"
    },
    {
        "name": "CT_OD_OVALITY",
        "isACTive": false,
        "description": "CT OD Ovality"
    },
    {
        "name": "CT_OFFSETDE",
        "isACTive": false,
        "description": "CT Offset"
    },
    {
        "name": "CT_RAW_DEPTH",
        "isACTive": false,
        "description": "CT Raw Depth"
    },
    {
        "name": "CT_RAW_DEPTH_PRECISION",
        "isACTive": false,
        "description": "CT Raw Depth Precision"
    },
    {
        "name": "CT_SLOPE",
        "isACTive": false,
        "description": "CT Slope"
    },
    {
        "name": "CT_SPEED",
        "isACTive": false,
        "description": "CT Speed"
    },
    {
        "name": "CT_TENSION",
        "isACTive": false,
        "description": "CT Tension"
    },
    {
        "name": "CT_WALL_AVG",
        "isACTive": false,
        "description": "CT Wall Thickness Average"
    },
    {
        "name": "CT_WALL_MAX",
        "isACTive": false,
        "description": "CT Wall Thickness Maximum"
    },
    {
        "name": "CT_WALL_MIN",
        "isACTive": false,
        "description": "CT Wall Thickness Mimimum"
    },
    {
        "name": "CT_WEIGHT",
        "isACTive": false,
        "description": "CT Weight"
    },
    {
        "name": "CUMULATIVE_JOB_VOLUME",
        "isACTive": false,
        "description": "CUMULATIVE_JOB_VOLUME"
    },
    {
        "name": "CURRENT_1",
        "isACTive": false,
        "description": "Current 1"
    },
    {
        "name": "CURRENT_2",
        "isACTive": false,
        "description": "Current 2"
    },
    {
        "name": "DEBUG_VARIABLE_1",
        "isACTive": false,
        "description": "Debug Variable 1"
    },
    {
        "name": "DEBUG_VARIABLE_10",
        "isACTive": false,
        "description": "Debug Variable 10"
    },
    {
        "name": "DEBUG_VARIABLE_11",
        "isACTive": false,
        "description": "Debug Variable 11"
    },
    {
        "name": "DEBUG_VARIABLE_12",
        "isACTive": false,
        "description": "Debug Variable 12"
    },
    {
        "name": "DEBUG_VARIABLE_13",
        "isACTive": false,
        "description": "Debug Variable 13"
    },
    {
        "name": "DEBUG_VARIABLE_14",
        "isACTive": false,
        "description": "Debug Variable 14"
    },
    {
        "name": "DEBUG_VARIABLE_15",
        "isACTive": false,
        "description": "Debug Variable 15"
    },
    {
        "name": "DEBUG_VARIABLE_16",
        "isACTive": false,
        "description": "Debug Variable 16"
    },
    {
        "name": "DEBUG_VARIABLE_17",
        "isACTive": false,
        "description": "Debug Variable 17"
    },
    {
        "name": "DEBUG_VARIABLE_18",
        "isACTive": false,
        "description": "Debug Variable 18"
    },
    {
        "name": "DEBUG_VARIABLE_2",
        "isACTive": false,
        "description": "Debug Variable 2"
    },
    {
        "name": "DEBUG_VARIABLE_3",
        "isACTive": false,
        "description": "Debug Variable 3"
    },
    {
        "name": "DEBUG_VARIABLE_4",
        "isACTive": false,
        "description": "Debug Variable 4"
    },
    {
        "name": "DEBUG_VARIABLE_5",
        "isACTive": false,
        "description": "Debug Variable 5"
    },
    {
        "name": "DEBUG_VARIABLE_6",
        "isACTive": false,
        "description": "Debug Variable 6"
    },
    {
        "name": "DEBUG_VARIABLE_7",
        "isACTive": false,
        "description": "Debug Variable 7"
    },
    {
        "name": "DEBUG_VARIABLE_8",
        "isACTive": false,
        "description": "Debug Variable 8"
    },
    {
        "name": "DEBUG_VARIABLE_9",
        "isACTive": false,
        "description": "Debug Variable 9"
    },
    {
        "name": "DENSITY",
        "isACTive": false,
        "description": "Density"
    },
    {
        "name": "DENSITY1",
        "isACTive": false,
        "description": "Density 1"
    },
    {
        "name": "DENSITY2",
        "isACTive": false,
        "description": "Density 2"
    },
    {
        "name": "DENSITY3",
        "isACTive": false,
        "description": "Density 3"
    },
    {
        "name": "DENSITY4",
        "isACTive": false,
        "description": "Density 4"
    },
    {
        "name": "DEPTH_END_BHA",
        "isACTive": false,
        "description": "Depth at End of BHA"
    },
    {
        "name": "DEPTH_LIMIT1",
        "isACTive": false,
        "description": "Depth Limit 1"
    },
    {
        "name": "DEPTH_LIMIT2",
        "isACTive": false,
        "description": "Depth Limit 2"
    },
    {
        "name": "DEPTH_OFFSET",
        "isACTive": false,
        "description": "Depth Offset"
    },
    {
        "name": "DOUBLE_PUMP_PRESSURE_1",
        "isACTive": false,
        "description": "Double Pump Pressure 1"
    },
    {
        "name": "DOUBLE_PUMP_PRESSURE_2",
        "isACTive": false,
        "description": "Double Pump Pressure 2"
    },
    {
        "name": "DOUBLE_PUMP_RATE_1",
        "isACTive": false,
        "description": "Double Pump Rate 1"
    },
    {
        "name": "DOUBLE_PUMP_RATE_2",
        "isACTive": false,
        "description": "Double Pump Rate 2"
    },
    {
        "name": "DOWNHOLE_FLOW_RATE_1",
        "isACTive": false,
        "description": "Downhole Flow Rate 1"
    },
    {
        "name": "DOWNHOLE_FLOW_RATE_2",
        "isACTive": false,
        "description": "Downhole Flow Rate 2"
    },
    {
        "name": "DOWNHOLE_FLOW_RATE_3",
        "isACTive": false,
        "description": "Downhole Flow Rate 3"
    },
    {
        "name": "DOWNHOLE_FLOW_RATE_4",
        "isACTive": false,
        "description": "Downhole Flow Rate 4"
    },
    {
        "name": "DOWNHOLE_GAMMA_RAY_1",
        "isACTive": false,
        "description": "Downhole Gamma Ray 1"
    },
    {
        "name": "DOWNHOLE_GAMMA_RAY_2",
        "isACTive": false,
        "description": "Downhole Gamma Ray 2"
    },
    {
        "name": "DOWNHOLE_OUTPUT_1",
        "isACTive": false,
        "description": "Downhole Output 1"
    },
    {
        "name": "DOWNHOLE_OUTPUT_2",
        "isACTive": false,
        "description": "Downhole Output 2"
    },
    {
        "name": "DOWNHOLE_OUTPUT_3",
        "isACTive": false,
        "description": "Downhole Output 3"
    },
    {
        "name": "DOWNHOLE_OUTPUT_4",
        "isACTive": false,
        "description": "Downhole Output 4"
    },
    {
        "name": "DOWNHOLE_OUTPUT_5",
        "isACTive": false,
        "description": "Downhole Output 5"
    },
    {
        "name": "DOWNHOLE_OUTPUT_6",
        "isACTive": false,
        "description": "Downhole Output 6"
    },
    {
        "name": "DOWNHOLE_PRESSURE_1",
        "isACTive": false,
        "description": "Downhole Pressure 1"
    },
    {
        "name": "DOWNHOLE_PRESSURE_2",
        "isACTive": false,
        "description": "Downhole Pressure 2"
    },
    {
        "name": "DOWNHOLE_PRESSURE_3",
        "isACTive": false,
        "description": "Downhole Pressure 3"
    },
    {
        "name": "DOWNHOLE_PRESSURE_4",
        "isACTive": false,
        "description": "Downhole Pressure 4"
    },
    {
        "name": "DOWNHOLE_PRESSURE_5",
        "isACTive": false,
        "description": "Downhole Pressure 5"
    },
    {
        "name": "DOWNHOLE_PRESSURE_6",
        "isACTive": false,
        "description": "Downhole Pressure 6"
    },
    {
        "name": "DOWNHOLE_TEMPERATURE_1",
        "isACTive": false,
        "description": "Downhole Temperature 1"
    },
    {
        "name": "DOWNHOLE_TEMPERATURE_2",
        "isACTive": false,
        "description": "Downhole Temperature 2"
    },
    {
        "name": "DOWNHOLE_TEMPERATURE_3",
        "isACTive": false,
        "description": "Downhole Temperature 3"
    },
    {
        "name": "DOWNHOLE_TEMPERATURE_4",
        "isACTive": false,
        "description": "Downhole Temperature 4"
    },
    {
        "name": "DOWNHOLE_VAR_1",
        "isACTive": false,
        "description": "Downhole Var 1"
    },
    {
        "name": "DOWNHOLE_VAR_2",
        "isACTive": false,
        "description": "Downhole Var 2"
    },
    {
        "name": "DOWNHOLE_VAR_3",
        "isACTive": false,
        "description": "Downhole Var 3"
    },
    {
        "name": "DOWNHOLE_VAR_4",
        "isACTive": false,
        "description": "Downhole Var 4"
    },
    {
        "name": "DOWNHOLE_VAR_5",
        "isACTive": false,
        "description": "Downhole Var 5"
    },
    {
        "name": "DOWNHOLE_VAR_6",
        "isACTive": false,
        "description": "Downhole Var 6"
    },
    {
        "name": "DOWNHOLE_VAR_7",
        "isACTive": false,
        "description": "Downhole Var 7"
    },
    {
        "name": "DOWNHOLE_VAR_8",
        "isACTive": false,
        "description": "Downhole Var 8"
    },
    {
        "name": "DPM_CURRENT_VALUE",
        "isACTive": false,
        "description": "CT Downhole Pressure Differential"
    },
    {
        "name": "DRILLING_DEPTH",
        "isACTive": false,
        "description": "Drilling Depth"
    },
    {
        "name": "DRILLING_ROP",
        "isACTive": false,
        "description": "Drilling ROP"
    },
    {
        "name": "DROPPED_PLUGS",
        "isACTive": false,
        "description": "Dropped Plugs"
    },
    {
        "name": "DRY_ADD1_TOT",
        "isACTive": false,
        "description": "Dry Add 1 Total"
    },
    {
        "name": "DRY_ADD2_TOT",
        "isACTive": false,
        "description": "Dry Add 2 Total"
    },
    {
        "name": "DRY_ADD3_TOT",
        "isACTive": false,
        "description": "Dry Add 3 Total"
    },
    {
        "name": "DRY_ADD4_TOT",
        "isACTive": false,
        "description": "Dry Add 4 Total"
    },
    {
        "name": "DRY_ADD_1_RATE",
        "isACTive": false,
        "description": "DRY_ADD_1_RATE"
    },
    {
        "name": "DRY_ADD_2_RATE",
        "isACTive": false,
        "description": "DRY_ADD_2_RATE"
    },
    {
        "name": "DRY_ADD_3_RATE",
        "isACTive": false,
        "description": "DRY_ADD_3_RATE"
    },
    {
        "name": "DRY_ADD_4_RATE",
        "isACTive": false,
        "description": "DRY_ADD_4_RATE"
    },
    {
        "name": "DRY_ADD_5_RATE",
        "isACTive": false,
        "description": "DRY_ADD_5_RATE"
    },
    {
        "name": "DSP_CCL",
        "isACTive": false,
        "description": "DSP CCL"
    },
    {
        "name": "DSP_DEPTH",
        "isACTive": false,
        "description": "DSP Depth"
    },
    {
        "name": "DSP_PRESS1",
        "isACTive": false,
        "description": "DSP Pressure 1"
    },
    {
        "name": "DSP_PRESS2",
        "isACTive": false,
        "description": "DSP Pressure 2"
    },
    {
        "name": "DSP_TEMPERATURE",
        "isACTive": false,
        "description": "DSP Temp"
    },
    {
        "name": "DS_PRESS_ACQ",
        "isACTive": false,
        "description": "DS_PRESS_ACQ"
    },
    {
        "name": "EMERG_STOP_FLAG",
        "isACTive": false,
        "description": "Emerg Stop Flag"
    },
    {
        "name": "ENGINE_KILL_CTU",
        "isACTive": false,
        "description": "Engine Kill CTU"
    },
    {
        "name": "ENGINE_LOAD_CTU",
        "isACTive": false,
        "description": "EngineLoadCTU"
    },
    {
        "name": "ENGINE_LOAD_PUMPER",
        "isACTive": false,
        "description": "EngineLoadPumper"
    },
    {
        "name": "ENGINE_OIL_PRESS_CTU",
        "isACTive": false,
        "description": "Engine Oil Press CTU"
    },
    {
        "name": "ENGINE_OIL_PRESS_PUMP",
        "isACTive": false,
        "description": "Engine Oil Press Pump"
    },
    {
        "name": "ENGINE_RPM",
        "isACTive": false,
        "description": "Engine RPM"
    },
    {
        "name": "ENGINE_RPM_CTU",
        "isACTive": false,
        "description": "Engine RPM CTU"
    },
    {
        "name": "ENGINE_RPM_PUMP",
        "isACTive": false,
        "description": "Engine RPM Pump"
    },
    {
        "name": "ENGINE_STATUS_CTU",
        "isACTive": false,
        "description": "Engine Status CTU"
    },
    {
        "name": "ENGINE_STATUS_PUMP",
        "isACTive": false,
        "description": "Engine Status Pump"
    },
    {
        "name": "ENGINE_TEMP_CTU",
        "isACTive": false,
        "description": "Engine Temp CTU"
    },
    {
        "name": "ENGINE_TEMP_PUMP",
        "isACTive": false,
        "description": "Engine Temp Pump"
    },
    {
        "name": "FL1_RATE",
        "isACTive": false,
        "description": "Fluid 1 Rate"
    },
    {
        "name": "FL2_RATE",
        "isACTive": false,
        "description": "Fluid 2 Rate"
    },
    {
        "name": "FL3_RATE",
        "isACTive": false,
        "description": "Fluid 3 Rate"
    },
    {
        "name": "FLND1_DENS",
        "isACTive": false,
        "description": "Fluid End 1 Density"
    },
    {
        "name": "FLND2_DENS",
        "isACTive": false,
        "description": "Fluid End 2 Density"
    },
    {
        "name": "FLND3_DENS",
        "isACTive": false,
        "description": "Fluid End 3 Density"
    },
    {
        "name": "FLOWMETER1_RATE",
        "isACTive": false,
        "description": "Flow meter rate 1"
    },
    {
        "name": "FLOWMETER2_RATE",
        "isACTive": false,
        "description": "Flow meter rate 2"
    },
    {
        "name": "FLOW_RATE_VAR_1",
        "isACTive": false,
        "description": "Flow Rate Var 1"
    },
    {
        "name": "FLOW_RATE_VAR_2",
        "isACTive": false,
        "description": "Flow Rate Var 2"
    },
    {
        "name": "FLOW_RATE_VAR_3",
        "isACTive": false,
        "description": "Flow Rate Var 3"
    },
    {
        "name": "FLOW_RATE_VAR_4",
        "isACTive": false,
        "description": "Flow Rate Var 4"
    },
    {
        "name": "FLOW_RATE_VAR_5",
        "isACTive": false,
        "description": "Flow Rate Var 5"
    },
    {
        "name": "FLOW_RATE_VAR_6",
        "isACTive": false,
        "description": "Flow Rate Var 6"
    },
    {
        "name": "FLOW_RATE_VAR_7",
        "isACTive": false,
        "description": "Flow Rate Var 7"
    },
    {
        "name": "FLOW_RATE_VAR_8",
        "isACTive": false,
        "description": "Flow Rate Var 8"
    },
    {
        "name": "FLUID_TEMP_PUMP",
        "isACTive": false,
        "description": "Fluid Temp Pump"
    },
    {
        "name": "FLUID_TRACKER_OUT_BHA_RATE",
        "isACTive": true,
        "description": "Downhole Flow Rate"
    },
    {
        "name": "FLUID_TRACKER_TOT_LIQ_PUMPED",
        "isACTive": true,
        "description": "FT Total Liquid Pumped "
    },
    {
        "name": "FLUID_TRACKER_TOT_N2_PUMPED",
        "isACTive": true,
        "description": "FT Total N2 Pumped "
    },
    {
        "name": "FOAMQUAL",
        "isACTive": false,
        "description": "Foam Quality"
    },
    {
        "name": "FOAM_FLOW_RATE_RECOMMENDED",
        "isACTive": false,
        "description": "FoamFlowRateRecommended"
    },
    {
        "name": "FOAM_QUAL",
        "isACTive": false,
        "description": "Foam Quality Alternate"
    },
    {
        "name": "FOAM_QUALITY_RECOMMENDED",
        "isACTive": false,
        "description": "FoamQualityRecommended"
    },
    {
        "name": "FQ_ANBOTTOMHOLE",
        "isACTive": true,
        "description": "Foam Quality AN BH"
    },
    {
        "name": "FQ_CTBOTTOMHOLE",
        "isACTive": true,
        "description": "Foam Quality CT BH"
    },
    {
        "name": "FQ_CTINJ",
        "isACTive": true,
        "description": "Foam Quality CT Inj"
    },
    {
        "name": "FRICTION_PRESS",
        "isACTive": false,
        "description": "Friction Pressure"
    },
    {
        "name": "GAS_RATE",
        "isACTive": false,
        "description": "Gas Rate"
    },
    {
        "name": "GEL_RATE",
        "isACTive": false,
        "description": "GEL_RATE"
    },
    {
        "name": "GROUND_TO_STRIP",
        "isACTive": false,
        "description": "Stripper to Ground"
    },
    {
        "name": "HHP",
        "isACTive": false,
        "description": "Hydraulic Horsepower"
    },
    {
        "name": "HYDROSTATIC_PRESS",
        "isACTive": false,
        "description": "Hydrostatic Pressure"
    },
    {
        "name": "HYD_PRESSURE_PUMP",
        "isACTive": false,
        "description": "Hyd Pressure Pump"
    },
    {
        "name": "HYD_SYS_PRESSURE_1_CTU",
        "isACTive": false,
        "description": "Hyd Sys Pressure 1 CTU"
    },
    {
        "name": "HYD_SYS_PRESSURE_2_CTU",
        "isACTive": false,
        "description": "Hyd Sys Pressure 2 CTU"
    },
    {
        "name": "HYD_TEMP_CTU",
        "isACTive": false,
        "description": "Hyd Temp CTU"
    },
    {
        "name": "HYD_TEMP_PUMP",
        "isACTive": false,
        "description": "Hyd Temp Pump"
    },
    {
        "name": "ICOILPLOT_CORRELATION_OFFSET",
        "isACTive": true,
        "description": "Correlation Depth Offset"
    },
    {
        "name": "IGAS_VOL",
        "isACTive": false,
        "description": "Incremental Gas Volume"
    },
    {
        "name": "IINJ_VOL",
        "isACTive": false,
        "description": "Incremental Injection Volume"
    },
    {
        "name": "ILIQ_VOL",
        "isACTive": false,
        "description": "Incremental Liquid Volume"
    },
    {
        "name": "INJECTOR_SIM_RAW_DEPTH",
        "isACTive": false,
        "description": "INJECTOR_SIM_RAW_DEPTH"
    },
    {
        "name": "INJ_DENS",
        "isACTive": false,
        "description": "Injection Density"
    },
    {
        "name": "INJ_HD_WEIGHT",
        "isACTive": false,
        "description": "Injector Head Weight"
    },
    {
        "name": "INJ_MOTOR_PRESS",
        "isACTive": false,
        "description": "Injector Motor Pressure"
    },
    {
        "name": "INJ_PRESS",
        "isACTive": false,
        "description": "Injection Pressure"
    },
    {
        "name": "INJ_RATE",
        "isACTive": false,
        "description": "Injection Rate"
    },
    {
        "name": "INJ_SPEED_RECOMMENDED",
        "isACTive": false,
        "description": "InjSpeedRecommended"
    },
    {
        "name": "IPROP_MS",
        "isACTive": false,
        "description": "Incremental Proppant"
    },
    {
        "name": "ISLUR_VOL",
        "isACTive": false,
        "description": "Incremental Slurry Volume"
    },
    {
        "name": "KCL_CONC",
        "isACTive": false,
        "description": "KCL Conc"
    },
    {
        "name": "KCL_RATE",
        "isACTive": false,
        "description": "KCL Rate"
    },
    {
        "name": "KCL_RATE",
        "isACTive": false,
        "description": "KCL_RATE"
    },
    {
        "name": "LEVEL_WIND",
        "isACTive": false,
        "description": "Level wind"
    },
    {
        "name": "LEVEL_WIND_OVERRIDE",
        "isACTive": false,
        "description": "Level wind Override"
    },
    {
        "name": "LIQUID_ADD_RATE_RECOMMENDED",
        "isACTive": false,
        "description": "LiquidAddRateRecommended"
    },
    {
        "name": "LIQ_1_RATE",
        "isACTive": false,
        "description": "LIQ_1_RATE"
    },
    {
        "name": "LIQ_2_RATE",
        "isACTive": false,
        "description": "LIQ_2_RATE"
    },
    {
        "name": "LOAD_LIMIT1",
        "isACTive": false,
        "description": "Load Limit 1"
    },
    {
        "name": "LOAD_LIMIT2",
        "isACTive": false,
        "description": "Load Limit 2"
    },
    {
        "name": "LOAD_LIMIT3",
        "isACTive": false,
        "description": "Load Limit 3"
    },
    {
        "name": "L_PRES1",
        "isACTive": false,
        "description": "Lower Lee Tool Pressure"
    },
    {
        "name": "L_PRES2",
        "isACTive": false,
        "description": "Upper Lee Tool Pressure"
    },
    {
        "name": "L_TEM1",
        "isACTive": false,
        "description": "Lower Lee Tool Temperature"
    },
    {
        "name": "L_TEM2",
        "isACTive": false,
        "description": "Upper Lee Tool Temperature"
    },
    {
        "name": "MICRO_MOTION_FLOWMETER2",
        "isACTive": false,
        "description": "Micro Motion Rate 2"
    },
    {
        "name": "MICRO_MOTION_FLOWMETER3",
        "isACTive": false,
        "description": "Micro Motion Rate 3"
    },
    {
        "name": "MICRO_MOTION_FLOWMETER4",
        "isACTive": false,
        "description": "Micro Motion Rate 4"
    },
    {
        "name": "MICRO_MOTION_RATE",
        "isACTive": false,
        "description": "Micro Motion Rate 1"
    },
    {
        "name": "MUD_PIT_VOLUME1",
        "isACTive": false,
        "description": "Mud Pit Volume 1"
    },
    {
        "name": "MUD_PIT_VOLUME2",
        "isACTive": false,
        "description": "Mud Pit Volume 2"
    },
    {
        "name": "MUD_PIT_VOLUME3",
        "isACTive": false,
        "description": "Mud Pit Volume 3"
    },
    {
        "name": "MUD_PIT_VOLUME4",
        "isACTive": false,
        "description": "Mud Pit Volume 4"
    },
    {
        "name": "MUD_PIT_VOLUME5",
        "isACTive": false,
        "description": "Mud Pit Volume 5"
    },
    {
        "name": "MUD_PIT_VOLUME6",
        "isACTive": false,
        "description": "Mud Pit Volume 6"
    },
    {
        "name": "MUD_PIT_VOLUME7",
        "isACTive": false,
        "description": "Mud Pit Volume 7"
    },
    {
        "name": "MUD_PIT_VOLUME8",
        "isACTive": false,
        "description": "Mud Pit Volume 8"
    },
    {
        "name": "MUD_PUMP_RATE1",
        "isACTive": false,
        "description": "Mud Pump Rate 1"
    },
    {
        "name": "MUD_PUMP_RATE2",
        "isACTive": false,
        "description": "Mud Pump Rate 2"
    },
    {
        "name": "MUD_PUMP_RATE3",
        "isACTive": false,
        "description": "Mud Pump Rate 3"
    },
    {
        "name": "MUD_PUMP_RATE4",
        "isACTive": false,
        "description": "Mud Pump Rate 4"
    },
    {
        "name": "N2FOAMQUAL",
        "isACTive": false,
        "description": "N2 Foam Quality"
    },
    {
        "name": "N2STGGAS",
        "isACTive": false,
        "description": "N2 Stage Gas"
    },
    {
        "name": "N2TOTGAS",
        "isACTive": false,
        "description": "N2 Total Gas"
    },
    {
        "name": "N2_DENSITY",
        "isACTive": false,
        "description": "N2 Density"
    },
    {
        "name": "N2_DISCHARGE_TEMP",
        "isACTive": false,
        "description": "N2 Discharge Temp"
    },
    {
        "name": "N2_DISCHARGE_VOL",
        "isACTive": false,
        "description": "N2 Discharge Vol"
    },
    {
        "name": "N2_PRESS",
        "isACTive": false,
        "description": "N2 Pressure"
    },
    {
        "name": "N2_PUMP_RPM",
        "isACTive": false,
        "description": "N2PumpRPM"
    },
    {
        "name": "N2_RATE",
        "isACTive": false,
        "description": "N2 Rate"
    },
    {
        "name": "N2_RATE1",
        "isACTive": false,
        "description": "N2 Rate (Backup 1)"
    },
    {
        "name": "N2_RATE2",
        "isACTive": false,
        "description": "N2 Rate 2"
    },
    {
        "name": "N2_RATE2",
        "isACTive": false,
        "description": "N2 Rate (Backup 2)"
    },
    {
        "name": "N2_RATE3",
        "isACTive": false,
        "description": "N2 Rate 3"
    },
    {
        "name": "N2_RATE4",
        "isACTive": false,
        "description": "N2 Rate 4"
    },
    {
        "name": "N2_RDM_RATE",
        "isACTive": false,
        "description": "N2 Roadmap Rate"
    },
    {
        "name": "N2_STD_DENS",
        "isACTive": false,
        "description": "Standard N2 Density"
    },
    {
        "name": "N2_TANK_PRESSURE",
        "isACTive": false,
        "description": "N2 Tank Pressure"
    },
    {
        "name": "N2_TANK_WEIGHT",
        "isACTive": false,
        "description": "N2 Tank Weight"
    },
    {
        "name": "N2_VOLUME",
        "isACTive": false,
        "description": "N2 Volume"
    },
    {
        "name": "N2_VOL_FACT",
        "isACTive": false,
        "description": "N2 Volume Factor"
    },
    {
        "name": "N2_WLHD_RATE",
        "isACTive": false,
        "description": "N2 Rate at Wellhead"
    },
    {
        "name": "NET_PRESS",
        "isACTive": false,
        "description": "Net Pressure"
    },
    {
        "name": "NS_SLOPE",
        "isACTive": false,
        "description": "Nolte-Smith Slope"
    },
    {
        "name": "NS_TIMER",
        "isACTive": false,
        "description": "Nolte-Smith Time"
    },
    {
        "name": "OVERALL_PUMP_RATE",
        "isACTive": false,
        "description": "Overall Pump Rate"
    },
    {
        "name": "OVERBALANCE_HIGH_RISK",
        "isACTive": false,
        "description": "Overbalance High Risk"
    },
    {
        "name": "OVERBALANCE_LOW_RISK",
        "isACTive": false,
        "description": "Overbalance Low Risk"
    },
    {
        "name": "PC_EXTENDED_VAR_1",
        "isACTive": false,
        "description": "PC Extended Var 1"
    },
    {
        "name": "PC_EXTENDED_VAR_10",
        "isACTive": false,
        "description": "PC Extended Var 10"
    },
    {
        "name": "PC_EXTENDED_VAR_2",
        "isACTive": false,
        "description": "PC Extended Var 2"
    },
    {
        "name": "PC_EXTENDED_VAR_3",
        "isACTive": false,
        "description": "PC Extended Var 3"
    },
    {
        "name": "PC_EXTENDED_VAR_4",
        "isACTive": false,
        "description": "PC Extended Var 4"
    },
    {
        "name": "PC_EXTENDED_VAR_5",
        "isACTive": false,
        "description": "PC Extended Var 5"
    },
    {
        "name": "PC_EXTENDED_VAR_6",
        "isACTive": false,
        "description": "PC Extended Var 6"
    },
    {
        "name": "PC_EXTENDED_VAR_7",
        "isACTive": false,
        "description": "PC Extended Var 7"
    },
    {
        "name": "PC_EXTENDED_VAR_8",
        "isACTive": false,
        "description": "PC Extended Var 8"
    },
    {
        "name": "PC_EXTENDED_VAR_9",
        "isACTive": false,
        "description": "PC Extended Var 9"
    },
    {
        "name": "PIPE_VERSUS_CHAIN",
        "isACTive": false,
        "description": "Pipe Versus Chain"
    },
    {
        "name": "POOH_SPEED_HIGH_RISK_VELOCITY",
        "isACTive": false,
        "description": "POOH CT Speed High Risk"
    },
    {
        "name": "POOH_SPEED_LOW_RISK_VELOCITY",
        "isACTive": false,
        "description": "POOH CT Speed Low Risk"
    },
    {
        "name": "PRESSURE_1",
        "isACTive": false,
        "description": "Pressure 1"
    },
    {
        "name": "PRESSURE_1",
        "isACTive": false,
        "description": "PRESSURE_1"
    },
    {
        "name": "PRESSURE_2",
        "isACTive": false,
        "description": "Pressure 2"
    },
    {
        "name": "PRESSURE_2",
        "isACTive": false,
        "description": "PRESSURE_2"
    },
    {
        "name": "PRESSURE_3",
        "isACTive": false,
        "description": "Pressure 3"
    },
    {
        "name": "PRESSURE_3",
        "isACTive": false,
        "description": "PRESSURE_3"
    },
    {
        "name": "PRESSURE_4",
        "isACTive": false,
        "description": "Pressure 4"
    },
    {
        "name": "PRESSURE_4",
        "isACTive": false,
        "description": "PRESSURE_4"
    },
    {
        "name": "PRESSURE_5",
        "isACTive": false,
        "description": "PRESSURE_5"
    },
    {
        "name": "PRESSURE_6",
        "isACTive": false,
        "description": "PRESSURE_6"
    },
    {
        "name": "PRESSURE_VAR_1",
        "isACTive": false,
        "description": "Pressure Var 1"
    },
    {
        "name": "PRESSURE_VAR_2",
        "isACTive": false,
        "description": "Pressure Var 2"
    },
    {
        "name": "PRESSURE_VAR_3",
        "isACTive": false,
        "description": "Pressure Var 3"
    },
    {
        "name": "PRESSURE_VAR_4",
        "isACTive": false,
        "description": "Pressure Var 4"
    },
    {
        "name": "PROP_CON",
        "isACTive": false,
        "description": "Proppant Conc"
    },
    {
        "name": "PROP_CON2",
        "isACTive": false,
        "description": "Proppant Conc Backup"
    },
    {
        "name": "PROP_RATE",
        "isACTive": false,
        "description": "Proppant Rate"
    },
    {
        "name": "PUMP1_RATE",
        "isACTive": false,
        "description": "Pump 1 Rate"
    },
    {
        "name": "PUMP2_RATE",
        "isACTive": false,
        "description": "Pump 2 Rate"
    },
    {
        "name": "PUMP3_RATE",
        "isACTive": false,
        "description": "Pump 3 Rate"
    },
    {
        "name": "PUMP4_RATE",
        "isACTive": false,
        "description": "Pump 4 Rate"
    },
    {
        "name": "PUMP5_RATE",
        "isACTive": false,
        "description": "Pump 5 Rate"
    },
    {
        "name": "PUMP6_RATE",
        "isACTive": false,
        "description": "Pump 6 Rate"
    },
    {
        "name": "PUMP7_RATE",
        "isACTive": false,
        "description": "Pump 7 Rate"
    },
    {
        "name": "PUMP8_RATE",
        "isACTive": false,
        "description": "Pump 8 Rate"
    },
    {
        "name": "PUMP_10_RATE",
        "isACTive": false,
        "description": "PUMP_10_RATE"
    },
    {
        "name": "PUMP_11_RATE",
        "isACTive": false,
        "description": "PUMP_11_RATE"
    },
    {
        "name": "PUMP_12_RATE",
        "isACTive": false,
        "description": "PUMP_12_RATE"
    },
    {
        "name": "PUMP_13_RATE",
        "isACTive": false,
        "description": "PUMP_13_RATE"
    },
    {
        "name": "PUMP_14_RATE",
        "isACTive": false,
        "description": "PUMP_14_RATE"
    },
    {
        "name": "PUMP_15_RATE",
        "isACTive": false,
        "description": "PUMP_15_RATE"
    },
    {
        "name": "PUMP_16_RATE",
        "isACTive": false,
        "description": "PUMP_16_RATE"
    },
    {
        "name": "PUMP_17_RATE",
        "isACTive": false,
        "description": "PUMP_17_RATE"
    },
    {
        "name": "PUMP_18_RATE",
        "isACTive": false,
        "description": "PUMP_18_RATE"
    },
    {
        "name": "PUMP_19_RATE",
        "isACTive": false,
        "description": "PUMP_19_RATE"
    },
    {
        "name": "PUMP_1_RATE",
        "isACTive": false,
        "description": "PUMP_1_RATE"
    },
    {
        "name": "PUMP_20_RATE",
        "isACTive": false,
        "description": "PUMP_20_RATE"
    },
    {
        "name": "PUMP_21_RATE",
        "isACTive": false,
        "description": "PUMP_21_RATE"
    },
    {
        "name": "PUMP_22_RATE",
        "isACTive": false,
        "description": "PUMP_22_RATE"
    },
    {
        "name": "PUMP_23_RATE",
        "isACTive": false,
        "description": "PUMP_23_RATE"
    },
    {
        "name": "PUMP_24_RATE",
        "isACTive": false,
        "description": "PUMP_24_RATE"
    },
    {
        "name": "PUMP_25_RATE",
        "isACTive": false,
        "description": "PUMP_25_RATE"
    },
    {
        "name": "PUMP_26_RATE",
        "isACTive": false,
        "description": "PUMP_26_RATE"
    },
    {
        "name": "PUMP_27_RATE",
        "isACTive": false,
        "description": "PUMP_27_RATE"
    },
    {
        "name": "PUMP_28_RATE",
        "isACTive": false,
        "description": "PUMP_28_RATE"
    },
    {
        "name": "PUMP_29_RATE",
        "isACTive": false,
        "description": "PUMP_29_RATE"
    },
    {
        "name": "PUMP_2_RATE",
        "isACTive": false,
        "description": "PUMP_2_RATE"
    },
    {
        "name": "PUMP_30_RATE",
        "isACTive": false,
        "description": "PUMP_30_RATE"
    },
    {
        "name": "PUMP_3_RATE",
        "isACTive": false,
        "description": "PUMP_3_RATE"
    },
    {
        "name": "PUMP_4_RATE",
        "isACTive": false,
        "description": "PUMP_4_RATE"
    },
    {
        "name": "PUMP_5_RATE",
        "isACTive": false,
        "description": "PUMP_5_RATE"
    },
    {
        "name": "PUMP_6_RATE",
        "isACTive": false,
        "description": "PUMP_6_RATE"
    },
    {
        "name": "PUMP_7_RATE",
        "isACTive": false,
        "description": "PUMP_7_RATE"
    },
    {
        "name": "PUMP_8_RATE",
        "isACTive": false,
        "description": "PUMP_8_RATE"
    },
    {
        "name": "PUMP_9_RATE",
        "isACTive": false,
        "description": "PUMP_9_RATE"
    },
    {
        "name": "PUMP_TIME",
        "isACTive": false,
        "description": "Pump Time"
    },
    {
        "name": "RAMP_VOLUME",
        "isACTive": false,
        "description": "Ramp Volume"
    },
    {
        "name": "RATE_1",
        "isACTive": false,
        "description": "Rate 1"
    },
    {
        "name": "RATE_2",
        "isACTive": false,
        "description": "Rate 2"
    },
    {
        "name": "RATE_3",
        "isACTive": false,
        "description": "Rate 3"
    },
    {
        "name": "RATE_4",
        "isACTive": false,
        "description": "Rate 4"
    },
    {
        "name": "RATE_ANN",
        "isACTive": false,
        "description": "Upper Lee Tool Rate"
    },
    {
        "name": "RATE_CT",
        "isACTive": false,
        "description": "Lower Lee Tool Rate"
    },
    {
        "name": "RDA1_IN1",
        "isACTive": false,
        "description": "RDA1_IN1"
    },
    {
        "name": "RDA1_IN10",
        "isACTive": false,
        "description": "RDA1_IN10"
    },
    {
        "name": "RDA1_IN11",
        "isACTive": false,
        "description": "RDA1_IN11"
    },
    {
        "name": "RDA1_IN12",
        "isACTive": false,
        "description": "RDA1_IN12"
    },
    {
        "name": "RDA1_IN2",
        "isACTive": false,
        "description": "RDA1_IN2"
    },
    {
        "name": "RDA1_IN3",
        "isACTive": false,
        "description": "RDA1_IN3"
    },
    {
        "name": "RDA1_IN4",
        "isACTive": false,
        "description": "RDA1_IN4"
    },
    {
        "name": "RDA1_IN5",
        "isACTive": false,
        "description": "RDA1_IN5"
    },
    {
        "name": "RDA1_IN6",
        "isACTive": false,
        "description": "RDA1_IN6"
    },
    {
        "name": "RDA1_IN7",
        "isACTive": false,
        "description": "RDA1_IN7"
    },
    {
        "name": "RDA1_IN8",
        "isACTive": false,
        "description": "RDA1_IN8"
    },
    {
        "name": "RDA1_IN9",
        "isACTive": false,
        "description": "RDA1_IN9"
    },
    {
        "name": "RDA2_IN1",
        "isACTive": false,
        "description": "RDA2_IN1"
    },
    {
        "name": "RDA2_IN10",
        "isACTive": false,
        "description": "RDA2_IN10"
    },
    {
        "name": "RDA2_IN11",
        "isACTive": false,
        "description": "RDA2_IN11"
    },
    {
        "name": "RDA2_IN12",
        "isACTive": false,
        "description": "RDA2_IN12"
    },
    {
        "name": "RDA2_IN2",
        "isACTive": false,
        "description": "RDA2_IN2"
    },
    {
        "name": "RDA2_IN3",
        "isACTive": false,
        "description": "RDA2_IN3"
    },
    {
        "name": "RDA2_IN4",
        "isACTive": false,
        "description": "RDA2_IN4"
    },
    {
        "name": "RDA2_IN5",
        "isACTive": false,
        "description": "RDA2_IN5"
    },
    {
        "name": "RDA2_IN6",
        "isACTive": false,
        "description": "RDA2_IN6"
    },
    {
        "name": "RDA2_IN7",
        "isACTive": false,
        "description": "RDA2_IN7"
    },
    {
        "name": "RDA2_IN8",
        "isACTive": false,
        "description": "RDA2_IN8"
    },
    {
        "name": "RDA2_IN9",
        "isACTive": false,
        "description": "RDA2_IN9"
    },
    {
        "name": "RDA3_IN1",
        "isACTive": false,
        "description": "RDA3_IN1"
    },
    {
        "name": "RDA3_IN10",
        "isACTive": false,
        "description": "RDA3_IN10"
    },
    {
        "name": "RDA3_IN11",
        "isACTive": false,
        "description": "RDA3_IN11"
    },
    {
        "name": "RDA3_IN12",
        "isACTive": false,
        "description": "RDA3_IN12"
    },
    {
        "name": "RDA3_IN2",
        "isACTive": false,
        "description": "RDA3_IN2"
    },
    {
        "name": "RDA3_IN3",
        "isACTive": false,
        "description": "RDA3_IN3"
    },
    {
        "name": "RDA3_IN4",
        "isACTive": false,
        "description": "RDA3_IN4"
    },
    {
        "name": "RDA3_IN5",
        "isACTive": false,
        "description": "RDA3_IN5"
    },
    {
        "name": "RDA3_IN6",
        "isACTive": false,
        "description": "RDA3_IN6"
    },
    {
        "name": "RDA3_IN7",
        "isACTive": false,
        "description": "RDA3_IN7"
    },
    {
        "name": "RDA3_IN8",
        "isACTive": false,
        "description": "RDA3_IN8"
    },
    {
        "name": "RDA3_IN9",
        "isACTive": false,
        "description": "RDA3_IN9"
    },
    {
        "name": "RDA4_IN1",
        "isACTive": false,
        "description": "RDA4_IN1"
    },
    {
        "name": "RDA4_IN10",
        "isACTive": false,
        "description": "RDA4_IN10"
    },
    {
        "name": "RDA4_IN11",
        "isACTive": false,
        "description": "RDA4_IN11"
    },
    {
        "name": "RDA4_IN12",
        "isACTive": false,
        "description": "RDA4_IN12"
    },
    {
        "name": "RDA4_IN2",
        "isACTive": false,
        "description": "RDA4_IN2"
    },
    {
        "name": "RDA4_IN3",
        "isACTive": false,
        "description": "RDA4_IN3"
    },
    {
        "name": "RDA4_IN4",
        "isACTive": false,
        "description": "RDA4_IN4"
    },
    {
        "name": "RDA4_IN5",
        "isACTive": false,
        "description": "RDA4_IN5"
    },
    {
        "name": "RDA4_IN6",
        "isACTive": false,
        "description": "RDA4_IN6"
    },
    {
        "name": "RDA4_IN7",
        "isACTive": false,
        "description": "RDA4_IN7"
    },
    {
        "name": "RDA4_IN8",
        "isACTive": false,
        "description": "RDA4_IN8"
    },
    {
        "name": "RDA4_IN9",
        "isACTive": false,
        "description": "RDA4_IN9"
    },
    {
        "name": "RDA5_IN1",
        "isACTive": false,
        "description": "RDA5_IN1"
    },
    {
        "name": "RDA5_IN10",
        "isACTive": false,
        "description": "RDA5_IN10"
    },
    {
        "name": "RDA5_IN11",
        "isACTive": false,
        "description": "RDA5_IN11"
    },
    {
        "name": "RDA5_IN12",
        "isACTive": false,
        "description": "RDA5_IN12"
    },
    {
        "name": "RDA5_IN2",
        "isACTive": false,
        "description": "RDA5_IN2"
    },
    {
        "name": "RDA5_IN3",
        "isACTive": false,
        "description": "RDA5_IN3"
    },
    {
        "name": "RDA5_IN4",
        "isACTive": false,
        "description": "RDA5_IN4"
    },
    {
        "name": "RDA5_IN5",
        "isACTive": false,
        "description": "RDA5_IN5"
    },
    {
        "name": "RDA5_IN6",
        "isACTive": false,
        "description": "RDA5_IN6"
    },
    {
        "name": "RDA5_IN7",
        "isACTive": false,
        "description": "RDA5_IN7"
    },
    {
        "name": "RDA5_IN8",
        "isACTive": false,
        "description": "RDA5_IN8"
    },
    {
        "name": "RDA5_IN9",
        "isACTive": false,
        "description": "RDA5_IN9"
    },
    {
        "name": "RDA6_IN1",
        "isACTive": false,
        "description": "RDA6_IN1"
    },
    {
        "name": "RDA6_IN10",
        "isACTive": false,
        "description": "RDA6_IN10"
    },
    {
        "name": "RDA6_IN11",
        "isACTive": false,
        "description": "RDA6_IN11"
    },
    {
        "name": "RDA6_IN12",
        "isACTive": false,
        "description": "RDA6_IN12"
    },
    {
        "name": "RDA6_IN2",
        "isACTive": false,
        "description": "RDA6_IN2"
    },
    {
        "name": "RDA6_IN3",
        "isACTive": false,
        "description": "RDA6_IN3"
    },
    {
        "name": "RDA6_IN4",
        "isACTive": false,
        "description": "RDA6_IN4"
    },
    {
        "name": "RDA6_IN5",
        "isACTive": false,
        "description": "RDA6_IN5"
    },
    {
        "name": "RDA6_IN6",
        "isACTive": false,
        "description": "RDA6_IN6"
    },
    {
        "name": "RDA6_IN7",
        "isACTive": false,
        "description": "RDA6_IN7"
    },
    {
        "name": "RDA6_IN8",
        "isACTive": false,
        "description": "RDA6_IN8"
    },
    {
        "name": "RDA6_IN9",
        "isACTive": false,
        "description": "RDA6_IN9"
    },
    {
        "name": "RDA_VAR_1",
        "isACTive": false,
        "description": "RDA Var 1"
    },
    {
        "name": "RDA_VAR_2",
        "isACTive": false,
        "description": "RDA Var 2"
    },
    {
        "name": "RDA_VAR_3",
        "isACTive": false,
        "description": "RDA Var 3"
    },
    {
        "name": "RDA_VAR_4",
        "isACTive": false,
        "description": "RDA Var 4"
    },
    {
        "name": "RDA_VAR_5",
        "isACTive": false,
        "description": "RDA Var 5"
    },
    {
        "name": "RDA_VAR_6",
        "isACTive": false,
        "description": "RDA Var 6"
    },
    {
        "name": "RDA_VAR_7",
        "isACTive": false,
        "description": "RDA Var 7"
    },
    {
        "name": "REEL_BRAKE_PRESSURE",
        "isACTive": false,
        "description": "Reel Brake Pressure"
    },
    {
        "name": "REEL_BRAKE_STATUS",
        "isACTive": false,
        "description": "Reel Brake Status"
    },
    {
        "name": "REEL_DIRECTION",
        "isACTive": false,
        "description": "Reel Direction"
    },
    {
        "name": "REEL_MOTOR_PRESS",
        "isACTive": false,
        "description": "Reel Motor Pressure"
    },
    {
        "name": "REEL_SPEED",
        "isACTive": false,
        "description": "Reel Speed"
    },
    {
        "name": "REEL_TENSION_RECOMMENDED",
        "isACTive": false,
        "description": "Reel Tension Recommended"
    },
    {
        "name": "REEL_WRAP_RADIUS",
        "isACTive": false,
        "description": "ReelWrapRadius"
    },
    {
        "name": "RETURNS_FLOW_RATE",
        "isACTive": false,
        "description": "Returns Flow Rate"
    },
    {
        "name": "RETURNS_VOLUME",
        "isACTive": false,
        "description": "Returns Volume"
    },
    {
        "name": "RET_DENS",
        "isACTive": false,
        "description": "Return Density"
    },
    {
        "name": "RET_RATE",
        "isACTive": false,
        "description": "Return Rate"
    },
    {
        "name": "RIH_POH",
        "isACTive": false,
        "description": "RIH_POH"
    },
    {
        "name": "RIH_SPEED_HIGH_RISK_VELOCITY",
        "isACTive": false,
        "description": "RIH CT Speed High Risk"
    },
    {
        "name": "RIH_SPEED_LOW_RISK_VELOCITY",
        "isACTive": false,
        "description": "RIH CT Speed Low Risk"
    },
    {
        "name": "SAMP_TIME",
        "isACTive": false,
        "description": "Sample Time"
    },
    {
        "name": "SCTR_DENS",
        "isACTive": false,
        "description": "Sand Conc Density"
    },
    {
        "name": "SHUT_IN_TIMER",
        "isACTive": false,
        "description": "Shut In Time"
    },
    {
        "name": "SKATE_PRESS",
        "isACTive": false,
        "description": "Skate Pressure"
    },
    {
        "name": "SKATE_PRESS1",
        "isACTive": false,
        "description": "Skate Pressure 1"
    },
    {
        "name": "SKATE_PRESS2",
        "isACTive": false,
        "description": "Skate Pressure 2"
    },
    {
        "name": "SKATE_PRESS3",
        "isACTive": false,
        "description": "Skate Pressure 3"
    },
    {
        "name": "SKATE_PRESSURE_RECOMMENDED",
        "isACTive": false,
        "description": "Skate Pressure Recommended"
    },
    {
        "name": "SLR_DEN_BU",
        "isACTive": false,
        "description": "Slurry Density (Backup)"
    },
    {
        "name": "SLUR_DENS",
        "isACTive": false,
        "description": "Slurry Density"
    },
    {
        "name": "SLUR_DENS",
        "isACTive": false,
        "description": "SLUR_DENS"
    },
    {
        "name": "SLUR_DENS2",
        "isACTive": false,
        "description": "SLUR_DENS2"
    },
    {
        "name": "SLUR_RATE",
        "isACTive": false,
        "description": "Slurry Rate"
    },
    {
        "name": "SLUR_RATE",
        "isACTive": false,
        "description": "SLUR_RATE"
    },
    {
        "name": "SLUR_RATE2",
        "isACTive": false,
        "description": "Slurry Rate Backup"
    },
    {
        "name": "SLUR_RATE2",
        "isACTive": false,
        "description": "SLUR_RATE2"
    },
    {
        "name": "SLUR_RATE2_TMP",
        "isACTive": false,
        "description": "SLUR_RATE2_TMP"
    },
    {
        "name": "SLUR_RATE_TMP",
        "isACTive": false,
        "description": "SLUR_RATE_TMP"
    },
    {
        "name": "SOLID_CONCENT_HIGH_RISK",
        "isACTive": false,
        "description": "Proppant Concentration High Risk"
    },
    {
        "name": "SOLID_CONCENT_LOW_RISK",
        "isACTive": false,
        "description": "Proppant Concentration Low Risk"
    },
    {
        "name": "STG_FLUID",
        "isACTive": false,
        "description": "Stage Fluid"
    },
    {
        "name": "STG_GAS",
        "isACTive": false,
        "description": "Stage Gas"
    },
    {
        "name": "STG_INJVOL",
        "isACTive": false,
        "description": "Stage Injected Volume"
    },
    {
        "name": "STG_PROP",
        "isACTive": false,
        "description": "Stage Proppant"
    },
    {
        "name": "STG_SLUR",
        "isACTive": false,
        "description": "Stage Slurry"
    },
    {
        "name": "STRIPPER_1_PRESSURE_RECOMMENDED",
        "isACTive": false,
        "description": "Stripper 1 Pressure Recommended"
    },
    {
        "name": "STRIPPER_2_PRESSURE_RECOMMENDED",
        "isACTive": false,
        "description": "Stripper 2 Pressure Recommended"
    },
    {
        "name": "STRIPPER_PRESS",
        "isACTive": false,
        "description": "Stripper Pressure"
    },
    {
        "name": "STRIPPER_PRESS1",
        "isACTive": false,
        "description": "Stripper Pressure 1"
    },
    {
        "name": "STRIPPER_PRESS2",
        "isACTive": false,
        "description": "Stripper Pressure 2"
    },
    {
        "name": "SUPPLY_PRESS",
        "isACTive": false,
        "description": "Supply Pressure"
    },
    {
        "name": "SURFACE_FLUID_0",
        "isACTive": false,
        "description": "Surface Fluid 1"
    },
    {
        "name": "SURFACE_FLUID_1",
        "isACTive": false,
        "description": "Surface Fluid 2"
    },
    {
        "name": "SURFACE_FLUID_2",
        "isACTive": false,
        "description": "Surface Fluid 3"
    },
    {
        "name": "SURFACE_FLUID_3",
        "isACTive": false,
        "description": "Surface Fluid 4"
    },
    {
        "name": "SURFACE_FLUID_4",
        "isACTive": false,
        "description": "Surface Fluid 5"
    },
    {
        "name": "SURFACE_FLUID_5",
        "isACTive": false,
        "description": "Surface Fluid 6"
    },
    {
        "name": "SURFACE_FLUID_6",
        "isACTive": false,
        "description": "Surface Fluid 7"
    },
    {
        "name": "SURFACE_FLUID_7",
        "isACTive": false,
        "description": "Surface Fluid 8"
    },
    {
        "name": "SURFACE_FLUID_8",
        "isACTive": false,
        "description": "Surface Fluid 9"
    },
    {
        "name": "SURFACE_FLUID_9",
        "isACTive": false,
        "description": "Surface Fluid 10"
    },
    {
        "name": "SURFACE_NITRIFIED",
        "isACTive": false,
        "description": "Nitrified Surface Fluid"
    },
    {
        "name": "SURFACTANT_CONC",
        "isACTive": false,
        "description": "Surfactant Pump Conc"
    },
    {
        "name": "SURFACTANT_RATE",
        "isACTive": false,
        "description": "Surfactant Pump Rate"
    },
    {
        "name": "SURF_FOAM_QUALITY",
        "isACTive": false,
        "description": "Surface Foam Quality"
    },
    {
        "name": "SURF_TEMP",
        "isACTive": false,
        "description": "Surface Temp"
    },
    {
        "name": "TAG_DEPTH",
        "isACTive": false,
        "description": "Input Depth"
    },
    {
        "name": "TEMPERATURE_VAR_1",
        "isACTive": false,
        "description": "Temperature Var 1"
    },
    {
        "name": "TEMPERATURE_VAR_2",
        "isACTive": false,
        "description": "Temperature Var 2"
    },
    {
        "name": "TEMPERATURE_VAR_3",
        "isACTive": false,
        "description": "Temperature Var 3"
    },
    {
        "name": "TEMPERATURE_VAR_4",
        "isACTive": false,
        "description": "Temperature Var 4"
    },
    {
        "name": "TENSION_MULT",
        "isACTive": false,
        "description": "Tension Multiplier"
    },
    {
        "name": "TIME_OF_DAY",
        "isACTive": false,
        "description": "Time Of Day"
    },
    {
        "name": "TIM_AVG_OD",
        "isACTive": false,
        "description": "TIM Avg OD"
    },
    {
        "name": "TIM_MAX_OD",
        "isACTive": false,
        "description": "TIM Max OD"
    },
    {
        "name": "TIM_MIN_OD",
        "isACTive": false,
        "description": "TIM Min OD"
    },
    {
        "name": "TIM_OD_1",
        "isACTive": false,
        "description": "TIMOD1"
    },
    {
        "name": "TIM_OD_10",
        "isACTive": false,
        "description": "TIMOD10"
    },
    {
        "name": "TIM_OD_2",
        "isACTive": false,
        "description": "TIMOD2"
    },
    {
        "name": "TIM_OD_3",
        "isACTive": false,
        "description": "TIMOD3"
    },
    {
        "name": "TIM_OD_4",
        "isACTive": false,
        "description": "TIMOD4"
    },
    {
        "name": "TIM_OD_5",
        "isACTive": false,
        "description": "TIMOD5"
    },
    {
        "name": "TIM_OD_6",
        "isACTive": false,
        "description": "TIMOD6"
    },
    {
        "name": "TIM_OD_7",
        "isACTive": false,
        "description": "TIMOD7"
    },
    {
        "name": "TIM_OD_8",
        "isACTive": false,
        "description": "TIMOD8"
    },
    {
        "name": "TIM_OD_9",
        "isACTive": false,
        "description": "TIMOD9"
    },
    {
        "name": "TIM_OVALITY",
        "isACTive": false,
        "description": "TIM Ovality"
    },
    {
        "name": "TOTAL_CEMENT_PUMP_RATE",
        "isACTive": false,
        "description": "Total Cement Pump Rate"
    },
    {
        "name": "TOTAL_FLOWMETER_RATE",
        "isACTive": false,
        "description": "Total Flowmeter Rate"
    },
    {
        "name": "TOTAL_FLOW_RATE",
        "isACTive": false,
        "description": "Total Flow Rate"
    },
    {
        "name": "TOTAL_FLUID",
        "isACTive": false,
        "description": "Total Fluid"
    },
    {
        "name": "TOTAL_FLUID_RATE",
        "isACTive": false,
        "description": "Total Fluid Rate"
    },
    {
        "name": "TOTAL_LIQUID_RATE",
        "isACTive": false,
        "description": "Total Liquid Rate"
    },
    {
        "name": "TOTAL_MICRO_MOTION_RATE",
        "isACTive": false,
        "description": "Total Micro Motion Rate"
    },
    {
        "name": "TOTAL_MUD_PUMP_RATE",
        "isACTive": false,
        "description": "Total Mud Pump Rate"
    },
    {
        "name": "TOTAL_N2_RATE",
        "isACTive": false,
        "description": "Total N2 Rate"
    },
    {
        "name": "TOTAL_PUMP_RATE",
        "isACTive": false,
        "description": "Total Pump Rate"
    },
    {
        "name": "TOTAL_RUNNING_FEET",
        "isACTive": false,
        "description": "Total Running Feet"
    },
    {
        "name": "TOT_FLUID",
        "isACTive": false,
        "description": "Total Fluid"
    },
    {
        "name": "TOT_GAS",
        "isACTive": false,
        "description": "Total Gas"
    },
    {
        "name": "TOT_INJVOL",
        "isACTive": false,
        "description": "Total Injection Volume"
    },
    {
        "name": "TOT_PROP",
        "isACTive": false,
        "description": "Total Proppant"
    },
    {
        "name": "TOT_PROP_BH",
        "isACTive": false,
        "description": "Total Proppant (BH)"
    },
    {
        "name": "TOT_SLUR",
        "isACTive": false,
        "description": "Total Slurry"
    },
    {
        "name": "TR_PRESS",
        "isACTive": false,
        "description": "Treating Pressure"
    },
    {
        "name": "TR_PRESS2",
        "isACTive": false,
        "description": "Treating Pressure Backup"
    },
    {
        "name": "TUBING_DIRECTION",
        "isACTive": false,
        "description": "Tubing Direction"
    },
    {
        "name": "TUBING_SPEED_LIMIT_1",
        "isACTive": false,
        "description": "Tubing Speed Limit 1"
    },
    {
        "name": "TUBING_SPEED_LIMIT_2",
        "isACTive": false,
        "description": "Tubing Speed Limit 2"
    },
    {
        "name": "UNIT1_IN1",
        "isACTive": false,
        "description": "UNIT1_IN1"
    },
    {
        "name": "UNIT1_IN2",
        "isACTive": false,
        "description": "UNIT1_IN2"
    },
    {
        "name": "UNIT1_IN3",
        "isACTive": false,
        "description": "UNIT1_IN3"
    },
    {
        "name": "UNIT1_IN4",
        "isACTive": false,
        "description": "UNIT1_IN4"
    },
    {
        "name": "UNIT1_IN5",
        "isACTive": false,
        "description": "UNIT1_IN5"
    },
    {
        "name": "UNIT1_IN6",
        "isACTive": false,
        "description": "UNIT1_IN6"
    },
    {
        "name": "UNIT2_IN1",
        "isACTive": false,
        "description": "UNIT2_IN1"
    },
    {
        "name": "UNIT2_IN2",
        "isACTive": false,
        "description": "UNIT2_IN2"
    },
    {
        "name": "UNIT2_IN3",
        "isACTive": false,
        "description": "UNIT2_IN3"
    },
    {
        "name": "UNIT2_IN4",
        "isACTive": false,
        "description": "UNIT2_IN4"
    },
    {
        "name": "UNIT2_IN5",
        "isACTive": false,
        "description": "UNIT2_IN5"
    },
    {
        "name": "UNIT2_IN6",
        "isACTive": false,
        "description": "UNIT2_IN6"
    },
    {
        "name": "UTLM_CALCULATED_DEPTH",
        "isACTive": false,
        "description": "UTLM_CALCULATED_DEPTH"
    },
    {
        "name": "UTLM_CALCULATED_SPEED",
        "isACTive": false,
        "description": "UTLM_CALCULATED_SPEED"
    },
    {
        "name": "VAP_BLOWER_SPEED",
        "isACTive": false,
        "description": "VapBlowerSpeed"
    },
    {
        "name": "VAP_TEMP_RECOMMENDED",
        "isACTive": false,
        "description": "VapTempRecommended"
    },
    {
        "name": "VISCOSITY",
        "isACTive": false,
        "description": "Viscosity"
    },
    {
        "name": "VISCOSITY2",
        "isACTive": false,
        "description": "Viscosity 2"
    },
    {
        "name": "VOLTAGE_1",
        "isACTive": false,
        "description": "Voltage 1"
    },
    {
        "name": "VOLTAGE_2",
        "isACTive": false,
        "description": "Voltage 2"
    },
    {
        "name": "VOLTAGE_CTU",
        "isACTive": false,
        "description": "Voltage CTU"
    },
    {
        "name": "VOLTAGE_PUMP",
        "isACTive": false,
        "description": "Voltage Pump"
    },
    {
        "name": "WC_BH_PRES",
        "isACTive": false,
        "description": "BH Pressure"
    },
    {
        "name": "WC_DIF",
        "isACTive": false,
        "description": "Dif"
    },
    {
        "name": "WC_PRES_INTEGRAL",
        "isACTive": false,
        "description": "Pressure Integral"
    },
    {
        "name": "WEIGHT_OFFSET",
        "isACTive": false,
        "description": "Initial Weight Offset"
    },
    {
        "name": "WH_PRESS",
        "isACTive": false,
        "description": "Well Head Pressure"
    },
    {
        "name": "WH_PRESS2",
        "isACTive": false,
        "description": "Well Head Pressure 2"
    },
    {
        "name": "WLHD_DENS",
        "isACTive": false,
        "description": "Wellhead Density"
    },
    {
        "name": "i_ACTIVE_XTREME_CUR",
        "isACTive": true,
        "description": "Battery current"
    },
    {
        "name": "i_ACTIVE_XTREME_QC",
        "isACTive": true,
        "description": "ACTive Xtreme QC"
    },
    {
        "name": "i_ANBHP",
        "isACTive": true,
        "description": "CT External Bottom Hole Pressure"
    },
    {
        "name": "i_BATT_D1",
        "isACTive": true,
        "description": "i_BATT_D1"
    },
    {
        "name": "i_BATT_D2",
        "isACTive": true,
        "description": "i_BATT_D2"
    },
    {
        "name": "i_BATT_S1",
        "isACTive": true,
        "description": "i_BATT_S1"
    },
    {
        "name": "i_BHT",
        "isACTive": true,
        "description": "CT External Bottom Hole Temperature"
    },
    {
        "name": "i_BHT_2",
        "isACTive": true,
        "description": "CT External Bottom Hole Temperature"
    },
    {
        "name": "i_BHT_TCS",
        "isACTive": true,
        "description": "T/C External Bottom Hole Temperature"
    },
    {
        "name": "i_CCL",
        "isACTive": true,
        "description": "Casing Collar Locator"
    },
    {
        "name": "i_CCL_DCT",
        "isACTive": true,
        "description": "CCL Detect"
    },
    {
        "name": "i_CCL_FLTD",
        "isACTive": true,
        "description": "Filtered CCL"
    },
    {
        "name": "i_CTBHP",
        "isACTive": true,
        "description": "CT Internal Bottom Hole Pressure"
    },
    {
        "name": "i_DEPTH_CCL_CENTER",
        "isACTive": true,
        "description": "CCL Correlated Depth"
    },
    {
        "name": "i_DEPTH_GR_CENTER",
        "isACTive": true,
        "description": "GR Depth Center"
    },
    {
        "name": "i_DEPTH_PT_CENTER",
        "isACTive": true,
        "description": "P/T Depth Center"
    },
    {
        "name": "i_DEPTH_TCS_CENTER",
        "isACTive": true,
        "description": "T/C Depth Center"
    },
    {
        "name": "i_DEPTH_TOOL_END",
        "isACTive": true,
        "description": "Tool End Depth"
    },
    {
        "name": "i_DFLO_QC",
        "isACTive": true,
        "description": "DFLO QC"
    },
    {
        "name": "i_DL_BIT_ERR",
        "isACTive": true,
        "description": "Bit errors on the downlink receiver at the FPGA"
    },
    {
        "name": "i_DL_CRC_ERR",
        "isACTive": true,
        "description": "Downlink CRC error at the DSP"
    },
    {
        "name": "i_DL_DECODE_ERR",
        "isACTive": true,
        "description": "Decoding errors inside the downlink receiver"
    },
    {
        "name": "i_DL_PKT_COUNT",
        "isACTive": true,
        "description": "Downlink received packet since power on"
    },
    {
        "name": "i_DL_TEL_RESETS",
        "isACTive": true,
        "description": "Number of times the downhole telemetry link (FPGA) is reset"
    },
    {
        "name": "i_DL_TEL_RESETS",
        "isACTive": true,
        "description": "Number of times the downhole telemetry link (FPGA) is reset"
    },
    {
        "name": "i_GAMMA",
        "isACTive": true,
        "description": "Gamma Ray"
    },
    {
        "name": "i_GAMMA_3_SEC",
        "isACTive": true,
        "description": "Gamma Ray 3 Sec"
    },
    {
        "name": "i_GAMMA_5_SEC",
        "isACTive": true,
        "description": "Gamma Ray 5 Sec"
    },
    {
        "name": "i_GAMMA_7_SEC",
        "isACTive": true,
        "description": "Gamma Ray 7 Sec"
    },
    {
        "name": "i_GR_QC",
        "isACTive": true,
        "description": "GR QC"
    },
    {
        "name": "i_ICTS001_BT",
        "isACTive": true,
        "description": "i_ICTS001_BT"
    },
    {
        "name": "i_ICTS002GR_3V3",
        "isACTive": true,
        "description": "i_ICTS002GR_3V3"
    },
    {
        "name": "i_ICTS002GR_5V",
        "isACTive": true,
        "description": "i_ICTS002GR_5V"
    },
    {
        "name": "i_ICTS002GR_BT",
        "isACTive": true,
        "description": "i_ICTS002GR_BT"
    },
    {
        "name": "i_ICTS002GR_CT",
        "isACTive": true,
        "description": "i_ICTS002GR_CT"
    },
    {
        "name": "i_ICTS002PT_3V3",
        "isACTive": true,
        "description": "i_ICTS002PT_3V3"
    },
    {
        "name": "i_ICTS002PT_5V",
        "isACTive": true,
        "description": "i_ICTS002PT_5V"
    },
    {
        "name": "i_ICTS002PT_BT",
        "isACTive": true,
        "description": "i_ICTS002PT_BT"
    },
    {
        "name": "i_ICTS002PT_CT",
        "isACTive": true,
        "description": "i_ICTS002PT_CT"
    },
    {
        "name": "i_IOLB_BATI",
        "isACTive": true,
        "description": "IOLB battery current"
    },
    {
        "name": "i_IOLB_BATV",
        "isACTive": true,
        "description": "IOLB battery voltage"
    },
    {
        "name": "i_IOLB_DOPM",
        "isACTive": true,
        "description": "IOLB download optical power"
    },
    {
        "name": "i_IOLB_UOPM",
        "isACTive": true,
        "description": "IOLB uplink optical power"
    },
    {
        "name": "i_LIVE",
        "isACTive": true,
        "description": "i_LIVE"
    },
    {
        "name": "i_OPTIFIRE_ACC_PEAK",
        "isACTive": true,
        "description": "Peak from accelerometer during firing"
    },
    {
        "name": "i_OPTIFIRE_CHARGE_CUR",
        "isACTive": true,
        "description": "Charging current"
    },
    {
        "name": "i_OPTIFIRE_CHARGE_VOLT",
        "isACTive": true,
        "description": "Charging voltage"
    },
    {
        "name": "i_OPTIFIRE_FIRING_VOLT",
        "isACTive": true,
        "description": "Firing voltage"
    },
    {
        "name": "i_OPTIFIRE_MAIN_CUR",
        "isACTive": true,
        "description": "Current from main board"
    },
    {
        "name": "i_OPTIFIRE_MAIN_QC",
        "isACTive": true,
        "description": "QC channel for main board"
    },
    {
        "name": "i_OPTIFIRE_MAIN_VOLT",
        "isACTive": true,
        "description": "Voltage from main board"
    },
    {
        "name": "i_OPTIFIRE_SAFETY_QC",
        "isACTive": true,
        "description": "QC channel for safety board"
    },
    {
        "name": "i_OPTIFIRE_STAT",
        "isACTive": true,
        "description": "OptiFIRE primary status indicator (i.e. the one displayed on all the OptiFIRE UIs)"
    },
    {
        "name": "i_PD_SCALED",
        "isACTive": true,
        "description": "Photodiode Received Power Measurement"
    },
    {
        "name": "i_PTC1_QC",
        "isACTive": true,
        "description": "PTC1 QC"
    },
    {
        "name": "i_PTC2_QC",
        "isACTive": true,
        "description": "PTC2 QC"
    },
    {
        "name": "i_PTC_AB_CURRENT",
        "isACTive": true,
        "description": "i_PTC_AB_CURRENT"
    },
    {
        "name": "i_RESET_COUNT",
        "isACTive": true,
        "description": "Cummulative number of DSP power-on/resets"
    },
    {
        "name": "i_STATUS",
        "isACTive": true,
        "description": "i_STATUS"
    },
    {
        "name": "i_TCS_QC",
        "isACTive": true,
        "description": "T/C QC"
    },
    {
        "name": "i_TEL_STATUS",
        "isACTive": true,
        "description": "Telemetry status"
    },
    {
        "name": "i_TORQUE",
        "isACTive": true,
        "description": "T/C Raw Torque"
    },
    {
        "name": "i_TORQUE_ACQ",
        "isACTive": true,
        "description": "T/C Raw Torque"
    },
    {
        "name": "i_TORQUE_ACQ_RAW",
        "isACTive": true,
        "description": "T/C Raw Torque"
    },
    {
        "name": "i_TORQUE_MW",
        "isACTive": true,
        "description": "T/C torque (from Maxwell)"
    },
    {
        "name": "i_TORQUE_OFFSET_MW",
        "isACTive": true,
        "description": "T/C torque offset (from Maxwell)"
    },
    {
        "name": "i_TORQUE_REF",
        "isACTive": true,
        "description": "T/C Torque Ref"
    },
    {
        "name": "i_TORQUE_REF_MW",
        "isACTive": true,
        "description": "T/C torque reference (from Maxwell)"
    },
    {
        "name": "i_TORQUE_REF_OFFSET_MW",
        "isACTive": true,
        "description": "T/C torque reference offset (from Maxwell)"
    },
    {
        "name": "i_UL_BIT_ERR",
        "isACTive": true,
        "description": "Uplink bit error"
    },
    {
        "name": "i_UL_CRC_ERR",
        "isACTive": true,
        "description": "Uplink crc error"
    },
    {
        "name": "i_UL_DECODE_ERR",
        "isACTive": true,
        "description": "Uplink decode error"
    },
    {
        "name": "i_UL_TEL_RESETS",
        "isACTive": true,
        "description": "Number of times the IOLB telemetry link (FPGA) is reset"
    },
    {
        "name": "i_WEIGHT",
        "isACTive": true,
        "description": "T/C Raw Weight"
    },
    {
        "name": "i_WEIGHT_ACQ",
        "isACTive": true,
        "description": "T/C Raw Weight"
    },
    {
        "name": "i_WEIGHT_ACQ_RAW",
        "isACTive": true,
        "description": "T/C Raw Weight"
    },
    {
        "name": "i_WEIGHT_CORRECTION_MW",
        "isACTive": true,
        "description": "T/C weight correction (from Maxwell)"
    },
    {
        "name": "i_WEIGHT_MW",
        "isACTive": true,
        "description": "T/C weight (from Maxwell)"
    },
    {
        "name": "i_WEIGHT_OFFSET_MW",
        "isACTive": true,
        "description": "T/C weight offset (from Maxwell)"
    },
    {
        "name": "i_WEIGHT_PRESS",
        "isACTive": true,
        "description": "T/C Pressure Corrected Weight"
    },
    {
        "name": "i_WEIGHT_PRESS_MW",
        "isACTive": true,
        "description": "T/C weight press (from Maxwell)"
    },
    {
        "name": "i_WEIGHT_PRESS_REF",
        "isACTive": true,
        "description": "T/C Pressure Corrected Weight At Zero Reference Baseline"
    },
    {
        "name": "i_WEIGHT_PRESS_REF_MW",
        "isACTive": true,
        "description": "T/C weight press reference (from Maxwell)"
    },
    {
        "name": "i_WEIGHT_PRESS_REF_OFFSET_MW",
        "isACTive": true,
        "description": "T/C weight press reference offset (from Maxwell)"
    },
    {
        "name": "i_WELLBORE",
        "isACTive": true,
        "description": "Known CCL Depth"
    }
]
